/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import { jsx } from '@emotion/core';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { ErrorBoundary } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import registerStyles from '../../../styles/registerStyles';
import { steps } from '../../../constants/registration';
// eslint-disable-next-line no-unused-vars
import OTP from './OTP';
// eslint-disable-next-line no-unused-vars
import Account from './Account';
// eslint-disable-next-line no-unused-vars
import Credentials from './Credentials';
import { credentialsFormInitData } from '../registerFormInitData';
import { fetchDialCodes } from '../../../utils/apiUtil';

const Registration = ({
  setErrorData,
  setIsRegistrationSuccess,
  registrationLocation,
  regId,
  rsvpCd,
}) => {
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  // registration step to be shown, OTP/Account/Credentials
  const [registrationStep, setRegistrationStep] = useState(steps.OTP);

  // Account detail data
  const [accountData, setAccountData] = useState({});

  // Credentials detail data
  const [credentialsData, setCredentialsData] = useState(
    credentialsFormInitData
  );

  const [dialCodes, setDialCodes] = useState([]);

  useEffect(() => {
    const getDialCodes = async () => {
      setDialCodes(await fetchDialCodes({ fxgApiHost }));
    };

    getDialCodes();
  }, [fxgApiHost]);

  const getCurrentStepComponent = useCallback(() => {
    // switch to the appropriate regitration form based on the current position
    switch (registrationStep.name) {
      case steps.OTP.name:
        return (
          <OTP
            setErrorData={setErrorData}
            setAccountData={setAccountData}
            setRegistrationStep={setRegistrationStep}
            registrationLocation={registrationLocation}
            regId={regId}
            rsvpCd={rsvpCd}
          />
        );
      case steps.ACCOUNT.name:
        return (
          <Account
            accountData={accountData}
            setAccountData={setAccountData}
            setRegistrationStep={setRegistrationStep}
            dialCodes={dialCodes}
          />
        );
      case steps.CREDENTIALS.name:
        return (
          <Credentials
            credentialsData={credentialsData}
            setCredentialsData={setCredentialsData}
            accountData={accountData}
            setRegistrationStep={setRegistrationStep}
            setIsRegistrationSuccess={setIsRegistrationSuccess}
            regId={regId}
            rsvpCd={rsvpCd}
          />
        );
      default:
        return <ErrorBoundary />;
    }
  }, [
    accountData,
    credentialsData,
    dialCodes,
    regId,
    registrationLocation,
    registrationStep.name,
    rsvpCd,
    setErrorData,
    setIsRegistrationSuccess,
  ]);

  return (
    <>
      <div css={registerStyles['.stepsContainer']}>
        SIGN UP
        <p className="dls-gray-04 margin-1-l">
          STEP {registrationStep.stepNo} OF 3
        </p>
      </div>

      <Heading
        headingStyle="heading6"
        level={1}
        theme={{ color: '#00175A' }}
        css={registerStyles['.registrationHeader']}
      >
        {registrationStep.header}
      </Heading>
      <div className="margin-3-tb">{getCurrentStepComponent()}</div>
    </>
  );
};

Registration.propTypes = {
  setErrorData: PropTypes.func.isRequired,
  setIsRegistrationSuccess: PropTypes.func.isRequired,
  registrationLocation: PropTypes.shape({}).isRequired,
  regId: PropTypes.string.isRequired,
  rsvpCd: PropTypes.string.isRequired,
};

export default Registration;
